import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function startCheckout(lookupKey) {
  try {
    const { data } = await axios.post(`${API}/payments/checkout`, {
      lookup_key: lookupKey,
      origin_url: window.location.origin,
    });
    if (data.checkout_url) {
      window.location.href = data.checkout_url;
    } else {
      toast.error("Could not start checkout. Please try again.");
    }
  } catch (e) {
    toast.error("Payment could not be started. Please call us for help.");
  }
}

export async function getPaymentStatus(sessionId) {
  const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
  return data;
}
